/*
 *  The MIT License (MIT)
 *
 * Copyright (c) 2016-2017 The Regents of the University of California
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
 * associated documentation files (the "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial
 * portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,  FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
 * ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

function tinyURLShortener({endpoint, apiKey, domain, tags}) {

    endpoint = endpoint || "https://api.tinyurl.com/create";

    if (!apiKey) {
        console.warn("TinyURL API key not provided. Custom domain will not work.");
        return async function (url) { return url }
    }

    return async function (url) {
        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiKey}`},
                body: JSON.stringify({ url, domain: domain || 't.3dg.io', tags: tags || ['spacewalk']})
            });

            if (response.ok) {
                const json = await response.json();
                return json.data.tiny_url;
            } else {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(`TinyURL API error: ${response.status} ${response.statusText} - ${errorData.message || 'Unknown error'}`);
            }
        } catch (error) {
            console.error('TinyURL shortening failed:', error);
            throw error;
        }
    }
}

export {tinyURLShortener}
